import { __asyncValues, __awaiter, __generator, __values } from "tslib";
import { debugLog } from '@graphql-tools/utils';
export function loadFile(pointer, options) {
    var e_1, _a;
    return __awaiter(this, void 0, void 0, function () {
        var cached, _b, _c, loader, canLoad, loadedValue, error_1, e_1_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    cached = useCache({ pointer: pointer, options: options });
                    if (cached) {
                        return [2 /*return*/, cached];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 11, 12, 17]);
                    _b = __asyncValues(options.loaders);
                    _d.label = 2;
                case 2: return [4 /*yield*/, _b.next()];
                case 3:
                    if (!(_c = _d.sent(), !_c.done)) return [3 /*break*/, 10];
                    loader = _c.value;
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 8, , 9]);
                    return [4 /*yield*/, loader.canLoad(pointer, options)];
                case 5:
                    canLoad = _d.sent();
                    if (!canLoad) return [3 /*break*/, 7];
                    return [4 /*yield*/, loader.load(pointer, options)];
                case 6:
                    loadedValue = _d.sent();
                    return [2 /*return*/, loadedValue];
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_1 = _d.sent();
                    debugLog("Failed to find any GraphQL type definitions in: " + pointer + " - " + error_1.message);
                    throw error_1;
                case 9: return [3 /*break*/, 2];
                case 10: return [3 /*break*/, 17];
                case 11:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 17];
                case 12:
                    _d.trys.push([12, , 15, 16]);
                    if (!(_c && !_c.done && (_a = _b.return))) return [3 /*break*/, 14];
                    return [4 /*yield*/, _a.call(_b)];
                case 13:
                    _d.sent();
                    _d.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 16: return [7 /*endfinally*/];
                case 17: return [2 /*return*/, undefined];
            }
        });
    });
}
export function loadFileSync(pointer, options) {
    var e_2, _a;
    var cached = useCache({ pointer: pointer, options: options });
    if (cached) {
        return cached;
    }
    try {
        for (var _b = __values(options.loaders), _c = _b.next(); !_c.done; _c = _b.next()) {
            var loader = _c.value;
            try {
                var canLoad = loader.canLoadSync && loader.loadSync && loader.canLoadSync(pointer, options);
                if (canLoad) {
                    return loader.loadSync(pointer, options);
                }
            }
            catch (error) {
                debugLog("Failed to find any GraphQL type definitions in: " + pointer + " - " + error.message);
                throw error;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return undefined;
}
function useCache(_a) {
    var pointer = _a.pointer, options = _a.options;
    if (options['cache']) {
        return options['cache'][pointer];
    }
}
//# sourceMappingURL=load-file.js.map